'use strict';

var _module2 = require('./module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_module3.default.directive('scopedTranscludeSlot', function () {
    return {
        restrict: 'EAC',
        link: function link($scope, $element, $attrs, controller, $transclude) {
            if (!$transclude) {
                return;
            }

            var slotName = $attrs['scopedTranscludeSlot'];

            $transclude($scope, function (clone) {
                $element.empty();
                $element.append(clone);
            },
            /*futureParentElement*/null, slotName);
        }
    };
}); // scoped-transclude, for ng-transclude-like behavior within another scope,
// e.g. ng-repeating the transclusion.
//
// This is used in addSource and addTarget.
//
// See https://github.com/angular/angular.js/issues/7874#issuecomment-47647528


//////////////////
// WEBPACK FOOTER
// ./src/core/scopedTranscludeSlot.js
// module id = 51
// module chunks = 0 2